import React, { useMemo } from 'react'

import Content from 'components/base/Content'
import Title from 'components/base/Title'
import ButtonRow from 'components/base/Button/Row'
import Button from 'components/base/Button'
import Form from 'components/base/Form'
import { Type as InputType } from 'components/base/Form/Input'
import InputGroup from 'components/base/Form/InputGroup'
import UserSuppliedText from 'components/base/UserSuppliedText'
import Link, { Theme as LinkTheme } from 'components/base/Link'
import QuotingWrapper, { Theme as QuotingWrapperTheme } from 'components/blocks/QuotingWrapper'

import { Props } from './types'

const QuotingEmail: React.FC<Props> = ({
  applicantFirstName,
  insuranceType,
  nextUrl,
  onSubmit,
}): React.ReactElement => {

  const nextButton = useMemo(() => {
    if (insuranceType && insuranceType.slug === 'health') {
      return (
        <Link
          showExternalIcon={true}
          to='/quote/new/health'
          theme={LinkTheme.button}
        >
          Start Your Quote
        </Link>
      )
    }

    return (
      <Button center={true} wide={true} isQuoteRequestNext={true}>
        Next
      </Button>
    )
  }, [ insuranceType ])

  return (
    <QuotingWrapper noPadding={true} theme={(insuranceType && insuranceType.slug) as string as QuotingWrapperTheme}>
      <Content center={true}>
        <Title level={3}>
          Thanks<UserSuppliedText>{(applicantFirstName && `, ${applicantFirstName}`) || undefined}</UserSuppliedText>.
          <br />
          Please provide your information so we can quote your {(insuranceType && `${insuranceType.name.toLowerCase()} `)}policy.
        </Title>
      </Content>
      <Content center={true} margined={true}>
        <Form short={true} nextUrl={nextUrl} onSubmit={onSubmit}>
          <InputGroup
            type={InputType.text}
            label='Email Address'
            name='email'
            quoteRequestField='applicant.address.email'
            rules='required|email'
          />
          <ButtonRow>{nextButton}</ButtonRow>
        </Form>
      </Content>
    </QuotingWrapper>
  )
}

export default QuotingEmail
